<template>
    <b-card>
        <b-card-header>
            <b-row>
                <b-col class="col-md-10">
                    <b-input
                        type="search"
                        placeholder="Filter..."
                        v-model="query"
                    ></b-input>
                </b-col>
                <b-col class="col text-right">
                    <b-button
                        variant="primary"
                        v-if="hasPermissionCreate"
                        @click="$emit('add-role')"
                        >Add Role</b-button
                    >
                </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <p class="mt-3">
                Page: {{ pagination.page }} of {{ pageCount }} Total:
                {{ pagination.total }}
            </p>
            <b-table id="roleTable" responsive :items="roles" :fields="fields">
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        v-if="hasPermissionView"
                        @click="view(row.item.id)"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>
            <b-row>
                <b-col>
                    <b-pagination
                        class="float-right"
                        v-model="pagination.page"
                        :total-rows="pagination.total"
                        :per-page="pagination.pageSize"
                        aria-controls="roleTable"
                        pills
                        align="right"
                    ></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
import _ from 'lodash'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

//import autoTable from 'jspdf-autotable'
export default {
    name: 'roles-table',
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            query: '',
            //template: false,
            fields: [{ key: 'id', label: 'Actions' }, 'name'],
        }
    },
    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },

    methods: {
        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        doSearch() {
            const { pagination: { page }, query } = this
            this.$store.dispatch('roles/fetch', {
                query,
                page,
            })
        },
        view(index) {
            const path = `${this.$route.path}/${index}`
            this.$router.push({ path })
        },
        truncate(text, length) {
            return _.truncate(text, { length: length })
        },
    },

    watch: {
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
    },

    computed: {
        roles() {
            return this.$store.state.roles.items
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        pagination() {
            return this.$store.state.roles.pagination || []
        },
        user() {
            return this.$store.state.user
        },
    },
}
</script>
<style></style>
